// @ts-nocheck
import { Divider, IconButton } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Field, reduxForm, submit, change } from 'redux-form';
import momentTz from 'moment-timezone';
import { ORANGE, RED, GREEN } from '../../_config/consts';
import * as ModalActions from '../../redux/actions/modal.actions';
import DeleteOutlineIconCustom from '../CustomIcons/DeleteOutlineIconCustom.jsx';
import TimezoneIconCustom from '../CustomIcons/TimezoneIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import DropFileField from './Fields/DropFileField.jsx';
import MDCheckBoxField from './Fields/MDCheckBox/MDCheckBoxField.js';
import SelectableField from './Fields/SelectableInput/SelectableField.jsx';
import MDSwitchView from './Fields/MDSwitch/MDSwitchView.jsx';

const validate = (values) => {
  const errors = [];
  return errors;
};

const DeviceRow = ({ item, onRemoveDevice, isEaven }) => {
  const backgroundColor = !isEaven ? '#FAFAFA' : 'white';
  
  const getAllTimeRangeGroups = () => {
    const groups = [];
    let index = 0;
    
    while (true) {
      const suffix = index === 0 ? '' : `_${index}`;
      const fromDate = item[`fromDate${suffix}`];
      const fromTime = item[`fromTime${suffix}`];
      const toDate = item[`toDate${suffix}`];
      const toTime = item[`toTime${suffix}`];
      const tr1TimeFrom = item[`TR1_dailyTimeFrom${suffix}`];
      const tr1TimeTo = item[`TR1_dailyTimeTo${suffix}`];
      const tr2TimeFrom = item[`TR2_dailyTimeFrom${suffix}`];
      const tr2TimeTo = item[`TR2_dailyTimeTo${suffix}`];
      
      if (!fromDate && !fromTime && !toDate && !toTime && !tr1TimeFrom && !tr1TimeTo && !tr2TimeFrom && !tr2TimeTo) {
        if (index === 0) {
          index = 1;
          continue;
        }
        break;
      }
      
      groups.push({
        index: index + 1,
        fromDate,
        fromTime,
        toDate,
        toTime,
        tr1TimeFrom,
        tr1TimeTo,
        tr2TimeFrom,
        tr2TimeTo
      });
      
      index = index === 0 ? 1 : index + 1;
    }
    
    return groups;
  };
  
  const renderTimeRangeGroup = (groupData) => {
    const { index, fromDate, fromTime, toDate, toTime, tr1TimeFrom, tr1TimeTo, tr2TimeFrom, tr2TimeTo } = groupData;
    
    const hasTR1 = tr1TimeFrom || tr1TimeTo;
    const hasTR2 = tr2TimeFrom || tr2TimeTo;
    
    const hasDateRange = fromDate || fromTime || toDate || toTime;
    
    if (!hasDateRange && !hasTR1 && !hasTR2) return null;
    
    const formatDateTimeRange = () => {
      const fromPart = moment(fromDate).format('LL');
      const toPart = moment(toDate).format('LL');
      return `${fromPart} ${fromTime ? ` ${fromTime}` : ''} - ${toPart} ${toTime ? ` ${toTime}` : ''}`;
    };
    
    return (
      <div key={index} style={{ marginTop: 6, borderLeft: '2px solid #e0e0e0', paddingLeft: 8 }}>
        <h6 style={{ margin: 0, marginBottom: 3, color: '#5f5f5f', fontSize: 12, fontWeight: 'bold' }}>
          Time Profile #{index}
        </h6>
        {hasDateRange && (
          <h6 style={{ margin: 0, marginTop: 2, color: '#7f7f7f', fontSize: 11 }}>
            Date: {formatDateTimeRange()}
          </h6>
        )}
        {hasTR1 && (
          <div style={{ marginTop: 2 }}>
            <h6 style={{ margin: 0, color: '#7f7f7f', fontSize: 11 }}>
              TR1: {tr1TimeFrom || 'N/A'} - {tr1TimeTo || 'N/A'}
            </h6>
          </div>
        )}
        {hasTR2 && (
          <div style={{ marginTop: 2 }}>
            <h6 style={{ margin: 0, color: '#7f7f7f', fontSize: 11 }}>
              TR2: {tr2TimeFrom || 'N/A'} - {tr2TimeTo || 'N/A'}
            </h6>
          </div>
        )}
      </div>
    );
  };
  
  const timeRangeGroups = getAllTimeRangeGroups();
  
  return (
    <div
      className="card-noHover tag-element-selected"
      style={{ display: 'flex', zIndex: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 5, marginBottom: 0, marginTop: 0, backgroundColor }}
    >
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', alignItems: 'flex-start' }}>
        <h5 style={{ margin: 0, color: '#3f3f3f', fontWeight: 'bold' }}>
          {item['badge UID'] || item.deviceId || 'N/A'}
        </h5>
        {item['username'] && (
          <h6 style={{ margin: 0, marginTop: 2, color: '#3f3f3f' }}>
            {item['username']}
          </h6>
        )}
        {item['badge Type'] && (
          <h6 style={{ margin: 0, marginTop: 2, color: '#7f7f7f', fontSize: 12 }}>
            Type: {item['badge Type']}
          </h6>
        )}
        {timeRangeGroups.length > 0 && (
          <div style={{ marginTop: 4 }}>
            {_.map(timeRangeGroups, group => renderTimeRangeGroup(group))}
          </div>
        )}
      </div>
    </div>
  );
};


@reduxForm({ form: 'ImportStandardDevicesCSVForm', validate })
@connect(state => ({ form: state.form.ImportStandardDevicesCSVForm }))
class ImportStandardDevicesCSVForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timezones: momentTz.tz.names(),
      guessedTimezone: momentTz.tz.guess(),
      showTimezoneSelector: false,
    };
  }

  componentDidMount() {
    const { guessedTimezone } = this.state;
    const { dispatch } = this.props;
    dispatch(change('ImportStandardDevicesCSVForm', 'timezone', guessedTimezone));
  }

  onFilterTimezones(value) {
    const timezones = momentTz.tz.names().filter(timezone => timezone.toLowerCase().includes(value.toLowerCase()));
    this.setState({ timezones });
  }

  onSelectTimezone(selectedOption) {
    const { dispatch } = this.props;
    const selectedTimezone = selectedOption && selectedOption.value ? selectedOption.value : momentTz.tz.guess();
    dispatch(change('ImportStandardDevicesCSVForm', 'timezone', selectedTimezone));
    this.setState({ guessedTimezone: selectedTimezone });
  }

  render() {
    const { dispatch, devices, onRemoveDevice, onDeleteFile, onFileAccepted, form } = this.props;
    const { guessedTimezone, showTimezoneSelector, timezones } = this.state;
    return (
      <Form>
        <FormFlatContainer
          title="importCardsFromCSV"
          containerStyle={{ marginRight: 10, marginTop: 20 }}
        >
          <Field
            name="csvFile"
            className="drop-file-container"
            activeClassName="drop-file-container-active"
            multiple={false}
            accept={['.xlsx', '.csv']}
            maxSize={20000000}
            component={DropFileField}
            onFileAccepted={(file) => onFileAccepted(file)}
            onFileRejected={() => dispatch(ModalActions.showModal({
              modalType: 'ERROR_MODAL',
              modalProps: { type: 'FILE_TOO_LARGE' },
            }))}
            onDeleteFile={f => onDeleteFile(f)}
          >
            <h5 style={{ marginBottom: 5 }}><Entity entity="dropFile" /></h5>
            <h5 style={{ marginTop: 0 }}><Entity entity="orSelect" /></h5>
          </Field>
          {devices && !_.isEmpty(devices) ? (
            <div>
              <Divider style={{ marginTop: 20, marginBottom: 10 }} />
              <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 20 }}>
                <Entity entity="updateIfRfidExists" />
              </h4>
              <Field
                name="updateIfExists"
                label={<Entity entity="updateIfRfidExists" />}
                titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
                component={MDCheckBoxField}
              />
                <h6 style={{ margin: 0, marginLeft: 32, marginTop: -5, color: '#7f7f7f', fontSize: 12 }}>
                  <Entity entity="updateIfRfidExistsDescription" />
                </h6>
                <Divider style={{ marginTop: 20, marginBottom: 10 }} />
                <div style={{ marginTop: 0 }}>
                {guessedTimezone ? (
                  <div>
                    <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 20 }}>
                      <Entity entity="buildingTimeZone" />
                    </h4>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 10, paddingLeft: 15, borderRadius: 10, background: '#f0f0f0' }}>
                      <TimezoneIconCustom style={{ width: 20, marginRight: 10 }} />
                      <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{guessedTimezone}</h5>
                    </div>
                    <MDSwitchView
                      label={<Entity key={showTimezoneSelector} entity="notYourTimeZone" />}
                      checked={showTimezoneSelector}
                      titleStyle={{ fontWeight: showTimezoneSelector ? 'bold' : 'normal', color: showTimezoneSelector ? GREEN : '#3f3f3f' }}
                      onSelect={selected => this.setState({ showTimezoneSelector: selected })}
                    />
                  </div>
                ) : null}
                {showTimezoneSelector ? (
                  <Field
                    name="timezone"
                    title={<Entity entity="selectTimezone" />}
                    component={SelectableField}
                    options={_.map(timezones, timezone => ({ value: timezone, label: timezone }))}
                    titleStyle={{ fontSize: 16 }}
                    placeholder={<Entity entity="search" />}
                    containerstyle={{ width: '100%', marginBottom: 20 }}
                    onInputChange={value => this.onFilterTimezones(value)}
                    onSelect={value => this.onSelectTimezone(value)}
                  />
                ) : null}
              </div>
              <Divider style={{ marginTop: 20, marginBottom: 10 }} />
              <div style={{ marginTop: 0 }}>
                <div style={{ display: 'inline-flex', flexDirection: 'row', alignItems: 'center' }}>
                <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 20 }}><Entity entity="selectedStandardDevices" /> ({_.size(devices)})</h4>
                </div>
                <div style={{ padding: 5, backgroundColor: '#f1f1f1', borderRadius: 10 }}>
                  <div style={{ maxHeight: 200, overflowY: 'scroll' }}>
                    <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                      {_.map(devices, (item, index) =>
                        <DeviceRow
                          key={index}
                          item={item}
                          isEaven={index % 2 === 0}
                          onRemoveDevice={() => onRemoveDevice(item)}
                        />,
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          <MDButton
            title={<Entity entity="import" />}
            disabled={_.isEmpty(devices)}
            containerStyle={{ margin: 0, marginTop: 20 }}
            onClick={() => dispatch(submit('ImportStandardDevicesCSVForm'))}
          />
        </FormFlatContainer>
      </Form>
    );
  }
} 

export default ImportStandardDevicesCSVForm;
